import React, { Component } from 'react';
import { Link } from 'gatsby';
import { getPrice } from '../../util/helpers';
import './CartModal.scss';

const countQuantity = (lineItems) => {
  let quantity = 0;
  lineItems.forEach((lineItem) => {
    quantity += lineItem.quantity;
  });
  return quantity;
};
const findAddedLineItem = (prevItems, currItems) => {
  const newCartItem = currItems.filter(currlineItem => (
    !prevItems.some(prevLineItem => (
      currlineItem.id === prevLineItem.id
    ))
  ));
  if (newCartItem && newCartItem.length > 0) return newCartItem[0];
  const changedQuantityCartItem = currItems.filter(currlineItem => (
    prevItems.some(prevLineItem => (
      (currlineItem.id === prevLineItem.id) && (currlineItem.quantity !== prevLineItem.quantity)
    ))
  ));
  if (changedQuantityCartItem && changedQuantityCartItem.length > 0) return changedQuantityCartItem[0];
  return null;
};

class CartModal extends Component {
  state = {
    visible: false,
    addedLineItem: null,
  };

  componentDidUpdate(prevProps) {
    const {
      adding: wasAdding,
      itemsInCart: prevCartItems,
    } = prevProps;
    const {
      adding: isAdding,
      itemsInCart: currCartItems,
    } = this.props;
    const prevQuantity = countQuantity(prevCartItems);
    const currQuantity = countQuantity(currCartItems);
    if (wasAdding !== isAdding) {
      if (currQuantity > prevQuantity) {
        const addedLineItem = findAddedLineItem(prevCartItems, currCartItems);
        document.body.classList.add('cart-modal-open');
        this.setState({ // eslint-disable-line
          visible: true,
          addedLineItem,
        });
      }
    }
  }

  closeModal = () => {
    this.setState({
      visible: false,
    });
    document.body.classList.remove('cart-modal-open');
  };

  render() {
    const {
      visible,
      addedLineItem,
    } = this.state;
    if (!addedLineItem) return null;
    const {
      title,
      variant,
      quantity,
    } = addedLineItem;
    const {
      price,
      image,
      selectedOptions,
    } = variant;
    return (
      <div className={`added-to-cart-modal ${visible ? 'visible' : 'hidden'}`}>
        <div className="container">
          <div className="header">
            <h2>Just Added!</h2>
            <button
              className="close-modal-button"
              type="button"
              aria-label="Close cart notification modal"
              onClick={event => this.closeModal(event)}
            >
              <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd" stroke="#2D235F" strokeLinecap="round" strokeWidth="1.5">
                  <path d="M1.049 1.546l17.677 17.678M18.726 1.546L1.05 19.224" />
                </g>
              </svg>
            </button>
          </div>
          <div className="line-item-image">
            <img src={image.src} alt={`${title} product shot`} />
          </div>
          <div className="line-item-details">
            <span className="line-item-title">{title}</span>
            { selectedOptions && (
              <>
                <ul className="line-item-options">
                  { selectedOptions.map((option, index) => {
                    if (option.name === 'Title') return null;
                    return (
                      <li
                        className="line-item-option"
                      >
                        <span className="option-value">{`${option.value}${index !== selectedOptions.length - 1 ? ' / ' : ''}`}</span>
                      </li>
                    );
                  })}
                  <li
                    className="line-item-option"
                  >
                    <span className="option-value">{`x ${quantity}`}</span>
                  </li>
                </ul>
              </>
            )}
            <span className="price-tag">{getPrice(price)}</span>
          </div>
          <div className="modal-actions">
            <Link
              to="/cart/"
              className="styled-button styled-button-primary go-to-cart-button"
              aria-label="Go to the Cart"
              onClick={event => this.closeModal(event)}
            >
              <span>View my cart</span>
            </Link>
            <button
              className="keep-shopping-button"
              type="button"
              aria-label="Close cart notification modal"
              onClick={event => this.closeModal(event)}
            >
              Continue shopping
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default CartModal;
